export function applyBrandTheme(brand) {
  if (!brand || !brand.colors) return

  const root = document.documentElement
  const colors = brand.colors

  root.style.setProperty("--main-color", colors.primary)
  root.style.setProperty("--main-color-hover", colors.primaryHover || colors.primary)

  root.style.setProperty("--secondary-color", colors.secondary)
  root.style.setProperty("--secondary-color-hover", colors.secondaryHover || colors.secondary)

  root.style.setProperty("--main-white", colors.white || "#FFFFFF")
  root.style.setProperty("--background-grey", colors.backgroundGrey || "#F3F3F3")
  root.style.setProperty("--main-grey", colors.grey || "#CCCCCC")

  root.style.setProperty("--main-green", colors.green || colors.primary)
  root.style.setProperty("--main-green-hover", colors.greenHover || colors.green)


  root.style.setProperty("--main-blue", colors.blue || "#394874")
  root.style.setProperty("--main-blue-hover", colors.blueHover || "#6D84C4")
  root.style.setProperty("--main-blue-light", colors.blueLight || "#B0BFE8")

  root.style.setProperty("--cobalt", colors.cobalt || "#394874")
  root.style.setProperty("--bleuet", colors.bleuet || "#6D84C4")
  root.style.setProperty("--dragee", colors.dragee || "#EAEDF4")
  root.style.setProperty("--klein", colors.klein || "#14248A")
  root.style.setProperty("--cyan", colors.cyan || "#009DFF")
  root.style.setProperty("--givre", colors.givre || "#06C9B3")
  root.style.setProperty("--lime", colors.lime || "#C2E812")
  root.style.setProperty("--orange", colors.orange || "#FF9D00")
  root.style.setProperty("--pink", colors.pink || "#FF21FF")
  root.style.setProperty("--blue-finance", colors.blueFinance || "#93A8E5")

  root.style.setProperty("--main-text-color", colors.text || "#07153C")
  root.style.setProperty("--main-color-text-table", colors.text || "#07153C")
  root.style.setProperty("--main-color-text", colors.text || "#07153C")
  root.style.setProperty("--secondary-text-color", colors.textSecondary || "#A5ABB2")
  root.style.setProperty("--tertiary-text-color", colors.textTertiary || "#6D84C4")


  root.style.setProperty("--avp-color", colors.avpColor)
  root.style.setProperty("--avp-color-hover", colors.avpColorHover)
  root.style.setProperty("--exe-color", colors.exeColor)
  root.style.setProperty("--exe-color-hover", colors.exeColorHover)


}




// WEBPACK FOOTER //
// ./src/utils/theme.js